<template>
    <div class="outer-box" >
      <h4>Add Business Profile Failure Reason</h4>

      <div class="inner-box" style="text-align: left; width: 500px;">
        <div>Location ID</div>
        <input
          class="hl_input--wrap "
          type="text"
          placeholder="Location ID"
          v-model="locationId"
        />
        <br />
        <br />
        <div>Company ID</div>
        <input
          class="hl_input--wrap "
          type="text"
          placeholder="Company ID"
          v-model="companyId"
        />
        <br />
        <br />
        <div>Customer Profile SID</div>
        <input
          class="hl_input--wrap "
          type="text"
          placeholder="Customer Profile SID"
          v-model="customerProfileSID"
        />
        <br />
        <br />
        <div>Failure Reason</div>
        <input
          class="hl_input--wrap "
          type="text"
          placeholder="Failure Reason"
          v-model="failureReason"
        />
        <br />
        <br />
        <button :disabled="disabled || processing" class="btn btn-primary mt-4" @click="addFailureReason">
          <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
          <span v-else>Add Failure Reason</span>
        </button>
        <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{response}}</pre>
      </div>
    </div>
  </template>

  <script>
  import { ISVService } from '@/services';

  export default {
    data() {
      return {
        locationId: '',
        companyId: '',
        customerProfileSID: '',
        failureReason: '',
        processing: false,
        response: null
      };
    },
    computed: {
      disabled() {
        if (!this.locationId || !this.companyId || !this.customerProfileSID || !this.failureReason) return true
        else return false
      }
    },
    methods: {
        addFailureReason(){
        this.processing = true
        ISVService.addBusinessProfileFailureReason(this.companyId, this.locationId, {
          customerProfileSID: this.customerProfileSID,
          failureReason: this.failureReason,
        })
          .then(response => {
            this.response = response.data
          })
          .catch(error => {
            this.response = error.response.data
          })
          .finally(() => {
            this.processing = false;
          });
      },
    }
  }
  </script>

  <style>
  </style>
